// extracted by mini-css-extract-plugin
export var orderSummary = "_r8-0";
export var showMoreLessButton = "_r8-1";